// 📄 components/integracion/CustomDevelopmentSection.tsx
// Bloque reutilizable de "Personalizaciones / Desarrollos Z" para la sección
// inferior de cualquier vista de Canal de Integración (Commerce y demás
// soluciones) — mismo patrón visual que el switch de OT, pero desplegando un
// formulario propio cuando se activa. El estado (per-step) lo maneja cada
// hook de canal, igual que ya hace con requiresOTMap/otNumberMap.
import { CustomDevelopmentData } from '../../types/customDevelopment.ts';

interface Props {
  value: CustomDevelopmentData;
  onChange: (data: CustomDevelopmentData) => void;
}

export default function CustomDevelopmentSection({ value, onChange }: Props) {
  const setField = (field: keyof CustomDevelopmentData, fieldValue: any) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className="border-t border-white/10 pt-4 space-y-3">
      <div className="flex items-center gap-3">
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={value.enabled || false}
            onChange={(e) => setField('enabled', e.target.checked)}
            className="sr-only peer"
          />
          <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-violet-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
        </label>
        <div>
          <span className="text-xs font-medium block">¿Aplica Personalización o Desarrollo Z en este paso/canal?</span>
          <span className="text-[10px] text-gray-400">Actívalo si el cliente requiere lógica custom, ampliación Z en BAdI, User Exit o Mapeo CIG personalizado.</span>
        </div>
      </div>

      {value.enabled && (
        <div className="bg-violet-500/5 border border-violet-500/20 rounded-xl p-4 space-y-3 animate-fadeIn">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Nombre de la Personalización</label>
            <input
              type="text"
              value={value.name || ''}
              onChange={(e) => setField('name', e.target.value)}
              placeholder="ej. Envío de campo custom en la OC"
              className="w-full bg-zinc-800 border border-white/10 rounded-xl p-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-violet-500"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Objeto / Lugar donde se realizó</label>
            <input
              type="text"
              value={value.location || ''}
              onChange={(e) => setField('location', e.target.value)}
              placeholder="ej. BAdI ARBCIG_BUY_PURCHORD_BADI / Método PUBLISH_PO_CREATE"
              className="w-full bg-zinc-800 border border-white/10 rounded-xl p-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-violet-500"
            />
          </div>

          <div className="max-w-xs">
            <label className="block text-xs font-medium text-gray-400 mb-1">Orden de Transporte (OT) Custom</label>
            <input
              type="text"
              value={value.otNumber || ''}
              onChange={(e) => setField('otNumber', e.target.value.toUpperCase())}
              maxLength={10}
              placeholder="ej. DEVK901234"
              className="w-full bg-zinc-800 border border-violet-500/30 text-violet-400 rounded-xl px-3 py-2 text-sm font-mono uppercase tracking-wider focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Código Z / Snippet Técnico</label>
            <textarea
              value={value.codeSnippet || ''}
              onChange={(e) => setField('codeSnippet', e.target.value)}
              placeholder="Pega aquí el fragmento ABAP, XML o expresión de mapeo..."
              rows={4}
              className="w-full bg-zinc-950 border border-white/10 rounded-xl p-2.5 text-xs text-emerald-300 placeholder-gray-500 font-mono focus:outline-none focus:border-violet-500 resize-y"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Comentarios de la Personalización</label>
            <textarea
              value={value.comments || ''}
              onChange={(e) => setField('comments', e.target.value)}
              placeholder="Justificación de negocio o instrucciones de prueba..."
              rows={2}
              className="w-full bg-white/5 border border-white/10 rounded-xl p-2.5 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-violet-500 resize-none"
            />
          </div>
        </div>
      )}
    </div>
  );
}
